/**
* LanguageContextManager.js
* 
* Created on 14-mei-2014, 13:37:41
*
* @author Ivo Swartjes for Ranj
**/

import ConversationTopicContent from "../../../../../../lib/html5-software-library/src/ranj/eng/content/dialog/ConversationTopicContent";
import KeyMomentChoiceContent from "../../../../../../lib/html5-software-library/src/ranj/eng/content/KeyMomentChoiceContent";
import QuizAnswerContent from "../../../../../../lib/html5-software-library/src/ranj/eng/content/QuizAnswerContent";
import TextContent from "../../../../../../lib/html5-software-library/src/ranj/eng/content/TextContent";

export default class LanguageContextHelper {

    static getRevisableLPLabelsForContent(languagePack, content) {
        var result = [];
        var contentType = content.getType();
        switch (contentType) {
            case TextContent.TYPE:
                result.push(languagePack.getFullLabel(TextContent.TEXT_LABEL, content.getLabel()));
                break;
            case ConversationTopicContent.TYPE:
                result.push(languagePack.getFullLabel(ConversationTopicContent.TOPIC_DESCRIPTION_LABEL, content.getLabel()));
                break;
            case KeyMomentChoiceContent.TYPE:
                result.push(languagePack.getFullLabel(KeyMomentChoiceContent.CHOICE_LABEL, content.getLabel()));
                break;
            case QuizAnswerContent.TYPE:
                result.push(languagePack.getFullLabel(QuizAnswerContent.ANSWER_LABEL, content.getLabel()));
                break;
        }
        return result;
    }
}
